<template>
    <el-table :data="economicGroups" style="width: 100%">
        <el-table-column prop="economicGroup" label="sacado" width="240">
            <template slot-scope="scope">
                <div class="d-flex justify-content-start align-items-center">
                    <div>
                        <NameInitials :name="scope.row.name" small />
                    </div>
                    <p class="break align-items-center medium c-ndarkfour">
                        {{ scope.row.name | formatName }}
                    </p>
                </div>
            </template>
        </el-table-column>
        <el-table-column prop="buyers" label="filiais" min-width="90">
            <template slot-scope="scope">
                <div class="d-flex justify-content-start align-items-center">
                    <p class="d-inline-block d-flex align-items-center medium c-ndarkfour">
                        {{ scope.row.buyers.length }}
                    </p>
                </div>
            </template>
        </el-table-column>
    </el-table>
</template>

<script>

import NameInitials from '@/components/icons/NameInitials'

export default {
    props: {
        economicGroups: {
            type: Array,
            required: true,
        },
    },
    components: {
        NameInitials,
    }
}

</script>

<style>

</style>